import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import { CallModel } from '../models/CallModel';
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import { SessionModel } from '../models/SessionModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface CallHistoryList {
    items: CallModel[];
    loading: boolean;
}

export interface CallHistoryLoad { type: 'CALLHISTORY_LOAD', newState: CallHistoryList }
export interface CallHistoryLoading { type: 'CALLHISTORY_LOADING' }

export type KnownAction = CallHistoryLoad | CallHistoryLoading | ResetStore;

const initialCallListState: CallHistoryList = {
    items: [],
    loading: false
};

export const actionCreators = {
    loadHistory: (pSession: SessionModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState();          
        
        var ServiceMasterNumber = pSession.SelectedSM.id;        
        var CompanyCode = pSession.SelectedAR.companyCode;
        try {

            dispatch({ type: 'CALLHISTORY_LOADING' });
            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/SD/LocationCallHistory?ServiceMaster=' + ServiceMasterNumber + '&CompanyCode=' + CompanyCode,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {
                    if (container.success) {
                        const data: CallModel[] = container.data;
                        dispatch({ type: 'CALLHISTORY_LOAD', newState: { items: data, loading: false } });
                    } else {

                        sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    }
                });
        } catch (e) {
            sawinFunc.log({ message: e, logType: LogTypes.Error, clientMessage: '' });
        }              
    },
    loadHistoryForEqp: (pSession: SessionModel, pEqpLog: number): AppThunkAction<KnownAction> => (dispatch, getState) => {
        //const appState = getState();          

        var ServiceMasterNumber = pSession.SelectedSM.id;
        var CompanyCode = pSession.SelectedAR.companyCode;
        try {

            dispatch({ type: 'CALLHISTORY_LOADING' });
            sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + `api/SD/LocationCallHistory?ServiceMaster=${ServiceMasterNumber}&CompanyCode=${CompanyCode}&EquipmentLog=${pEqpLog}`,
                {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(response => response.json() as Promise<APIContainer>)
                .then(container => {
                    if (container.success) {
                        const data: CallModel[] = container.data;
                        dispatch({ type: 'CALLHISTORY_LOAD', newState: { items: data, loading: false } });
                    } else {

                        sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                    }
                });
        } catch (e) {
            sawinFunc.log({ message: e, logType: LogTypes.Error, clientMessage: '' });
        }
    }
};

export const reducer: Reducer<CallHistoryList> = (state: CallHistoryList | undefined, incomingAction: Action): CallHistoryList => {

    if (state === undefined) {
        return { ...initialCallListState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CALLHISTORY_LOADING':
            return {...state, loading:true }
        case 'CALLHISTORY_LOAD':            
            const loadHistoryAction = incomingAction as CallHistoryLoad;            
            return loadHistoryAction.newState;
        case 'STORE_RESET':
            return { ...initialCallListState };
        default:   
            return state;
    }
}; 